function TravelodgesLogo({ variant = 'default', className = '' }) {
  const variants = {
    default: {
      container: 'flex items-center space-x-4',
      img: 'h-28 w-auto object-contain',
      textContainer: 'flex flex-col',
      mainText: 'text-3xl font-bold text-gray-900 leading-none',
      subText: 'text-sm text-emerald-600 font-medium tracking-wider uppercase'
    },
    small: {
      container: 'flex items-center space-x-3',
      img: 'h-16 w-auto object-contain',
      textContainer: 'flex flex-col',
      mainText: 'text-xl font-bold text-gray-900 leading-none',
      subText: 'text-[10px] text-emerald-600 font-medium tracking-wider uppercase'
    },
    footer: {
      container: 'flex items-center space-x-5',
      img: 'h-32 w-auto object-contain bg-white rounded-lg p-4',
      textContainer: 'flex flex-col',
      mainText: 'text-xl font-bold text-white leading-none',
      subText: 'text-xs text-emerald-400 font-medium tracking-wider uppercase'
    }
  };

  const style = variants[variant];

  return (
    <div className={`${style.container} ${className}`}>
      <img 
        src="/travelodges-logo-new.jpg" 
        alt="Travelodges Logo" 
        className={style.img}
      />
      <div className={style.textContainer}>
        <span className={style.mainText}>Travelodges</span>
        <span className={style.subText}>Connecting Resorts</span>
      </div>
    </div>
  );
}

export default TravelodgesLogo;
